import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-status',
  templateUrl: './loan-status.component.html',
  styleUrls: ['./loan-status.component.scss'],
})
export class LoanStatusComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
